import { capitalize } from 'element-ui/src/utils/util';

const _ = require('lodash');

function dataAdapterCities(data) {
  return _.map(data, (value) => _.mapKeys(value, (val, key) => capitalize(key)));
}
function dataAdapterCountry(cities, countries) {
  // _.map(cities, (city) => {
  //
  // })
  // const citiesDelivery = _.filter(cities, (v) => (v.Delivery_lap === true));
  // _.map(citiesDelivery, (city) => )
  // const citiesReception = _.filter(cities, (v) => (v.Reception_lap === true));
  // console.log(countries);
  // console.log(citiesDelivery);
  // console.log(citiesReception);
  return countries;
}

export {
  dataAdapterCities,
  dataAdapterCountry,
};
